import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";

// components
import PageHeader from "components/BreadCrumb";
import CustomPagination from "components/CustomPagination ";
import UserTableFilters from "components/TableFilters/UserTableFilters";

// hooks
import { useTable } from "hooks/custom/useTable";
import { useDeleteUser, useGetUsers } from "hooks/api/admin";
import { CSVLink } from "react-csv";

const User = () => {
  const history = useHistory();

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } =
    useTable();

  const { data: users, refetch } = useGetUsers();
  const deleteChapter = useDeleteUser(refetch);

  useEffect(() => {
    if (users?.data) {
      setRows(users?.data);
      setLoading(false);
    }
  }, [users?.data]);

  return (
    <div className="container-fluid">
      <PageHeader HeaderText="Users" Breadcrumb={[{ name: "Users" }]} />

      <div className="card">
        <div
          className="header"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h2>All Users</h2>

          <div
            style={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
            }}
          >
            <CSVLink filename={"all-users.csv"} data={rows}>
              {" "}
              <button type="button" className="btn btn-primary">
                <span className="mx-1">Export Users</span>
                <i className="fa fa-download"></i>
              </button>
            </CSVLink>

            <Link to="/users/create">
              <button
                type="button"
                className="btn btn-success"
                title="Create User"
              >
                <span className="sr-only">Create User</span>
                <i className="fa fa-plus mr-1"></i> <span>Create User</span>
              </button>
            </Link>
          </div>
        </div>

        <UserTableFilters
          data={users?.data || []}
          setRows={setRows}
          searchKey="name"
        />

        <div className="body table-responsive">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>name</th>
                <th>email</th>
                <th>role</th>
                <th style={{ textAlign: "end" }}>ACTIONS</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td></td>
                  <td></td>
                  <td
                    style={{
                      textAlign: "center",
                      height: "30vh",
                      width: "100%",
                    }}
                    className="visible-lg"
                  >
                    <i className="fa fa-spinner fa-4x fa-spin"></i>
                  </td>
                  <td></td>
                </tr>
              ) : (
                <>
                  {rows?.length > 0 ? (
                    rows
                      ?.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      ?.map((row) => (
                        <tr key={row.id}>
                          <th scope="row">{row.name}</th>
                          <td>{row.email}</td>
                          <td>{row?.rolename}</td>

                          <td
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            <button
                              type="button"
                              className="btn btn-warning mr-1"
                              title="Edit"
                              onClick={() =>
                                history.push(`/users/edit/${row.id}`)
                              }
                            >
                              <span className="sr-only">Edit</span>
                              <i className="fa fa-edit"></i>
                            </button>
                            <button
                              type="button"
                              className="btn btn-danger"
                              title="Delete"
                              onClick={() => deleteChapter.mutate(row.id)}
                            >
                              <span className="sr-only">Delete</span>
                              <i className="fa fa-trash-o"></i>
                            </button>
                          </td>
                        </tr>
                      ))
                  ) : (
                    <tr>
                      <td></td>
                      <td></td>
                      <td
                        style={{
                          textAlign: "center",
                          height: "30vh",
                          fontSize: "1.5rem",
                          width: "100%",
                        }}
                      >
                        Oops! No data found
                      </td>
                      <td></td>
                    </tr>
                  )}
                </>
              )}
            </tbody>
          </table>
        </div>

        <div className="body" style={{ paddingTop: 0, paddingBottom: 0 }}>
          <CustomPagination
            count={rows.length}
            page={page}
            rowsPerPage={rowsPerPage}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </div>
    </div>
  );
};

export default User;
